var map = {
	"./accuracy.svg": 5726,
	"./arrow-down.svg": 649,
	"./arrow-right.svg": 5353,
	"./arrow-up.svg": 9510,
	"./deliver.svg": 4944,
	"./ism.svg": 5514,
	"./nav-menu.svg": 4,
	"./pain-spot.svg": 1002,
	"./punctuality.svg": 7869,
	"./quotation-mark-after.svg": 4544,
	"./quotation-mark-front.svg": 279,
	"./radar-chart.svg": 208,
	"./remote-warehouse.svg": 4429,
	"./search.svg": 8217,
	"./the-earth.svg": 6761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;